import React from 'react'
import { Route, Switch } from 'react-router'
import ReportVehicleCosts from './ReportVehicleCosts'

const Components = props => (
    <Switch>
        <Route exact path={`${props.match.url}/:year?`} component={ReportVehicleCosts} />
    </Switch>
)

export default Components
